import classNames from "classnames";
import { FunctionComponent, ReactNode } from "react";
import styles from "../stylesheets/components/typography-wrapper.module.css";

interface Props {
  className?: string;
  children: ReactNode;
}

const TypographyWrapper: FunctionComponent<Props> = ({
  className,
  children,
}) => {
  return (
    <div className={classNames(styles.TypographyWrapper, className)}>
      {children}
    </div>
  );
};

export default TypographyWrapper;
